import type {TenantBankAccount} from './TenantBankAccount';

export type BalancePaymentCardPaymentRequestBody = {
  paymentDiscriminator: BalancePaymentCardPaymentRequestBody.paymentDiscriminator;
  paymentMethod: BalancePaymentCardPaymentRequestBody.paymentMethod;
  dueDate: string;
  comment: string;
  tenantBankAccount?: TenantBankAccount | null;
  cashRegisterId: string;
  createCashRegisterDocument: boolean | null;
  exchangeRate: string | null;
  supplierInvoiceNumber: string | null;
  dateOfTaxableSupply: string | null;
};

export namespace BalancePaymentCardPaymentRequestBody {
  export enum paymentDiscriminator {
    BALANCE = 'BALANCE',
  }

  export enum paymentMethod {
    PAYMENT_CARD = 'PAYMENT_CARD',
  }
}
